import * as React from 'react';

import { Paper, Typography, LinearProgress, Table, TableBody, TableCell, TableRow, Button, Dialog, DialogTitle, DialogContent, Grid, DialogActions } from '@material-ui/core';

// tslint:disable-next-line:no-empty-interface
export interface IPublisherSkuSoldAnalyticalProps {
    list: any[],
    loading: boolean,
    title: string
}

// tslint:disable-next-line:no-empty-interface
export interface IPublisherSkuSoldAnalyticalState {
    dialogOpen: boolean
}

const dataFilled = (list: any) => {
    return list && !!list.length
}

export class PublisherSkuSoldAnalytical extends React.Component<IPublisherSkuSoldAnalyticalProps, IPublisherSkuSoldAnalyticalState> {
    constructor(props: IPublisherSkuSoldAnalyticalProps) {
        super(props);
        this.state = {
            dialogOpen: false
        }
    }

    public render() {
        return  (
            <Paper className="publisher-sale-block panel-block">
                <Typography variant="headline" className="panel-title" component="title">
                    {this.props.title}
                </Typography>
                {
                    this.props.loading ? <LinearProgress /> : (
                        dataFilled(this.props.list)
                        ?
                        this.renderTable(this.props.list)
                        :
                        (<Typography variant="body2" className="comparative" component="p">
                            Não há informações de vendas
                        </Typography>)
                    )
                }
            </Paper>
        );
    }

    private renderTable(list:any[]) {
        list.sort((obj1:any, obj2:any) => {
            if(obj1.title.toUpperCase() > obj2.title.toUpperCase()) {
                return 1;
            } else if(obj1.title.toUpperCase() < obj2.title.toUpperCase()){
                return -1;
            } else {
                return 0;
            }
        });
        return (
            <div>
                <div style={{height: 334, overflowX: 'auto', overflowY: 'hidden'}}>
                    <Table>
                        <TableBody>
                            { list && list.map( (row:any, index) =>
                                (<TableRow key={index}>
                                    <TableCell style={{paddingRight: 0, paddingLeft: 10}}> { index + 1 } </TableCell>
                                    <TableCell style={{paddingRight: 0}}>{row.sku}</TableCell>
                                    <TableCell style={{paddingRight: 0}}>{row.title}</TableCell>
                                </TableRow>)   ) }
                        </TableBody>
                    </Table>
                </div>
                <div>
                    <div className="filter-item">
                        <Button onClick={this.handleDialogOpen} color="primary">
                        Ver Mais
                        </Button>
                        <Dialog
                            fullScreen={true}
                            open={this.state.dialogOpen}
                            onClose={this.handleDialogClose}
                            aria-labelledby="share-table-modal-group-dialog-title"
                            aria-describedby="share-table-modal-group-dialog-description"
                            className="share-table-modal-dialog"
                        >
                            <DialogTitle
                                className="share-table-modal-dialog-title"
                                id="share-table-modal-group-dialog-title"
                            >
                                {this.props.title}
                            </DialogTitle>
                            <DialogContent className="share-table-modal-dialog-content">
                                <Paper className="shared-share-sharetablemodal-block panel-block">
                                    <Grid container={true} spacing={16}>

                                        <Typography
                                            variant="headline"
                                            className="table-title"
                                            component="title"
                                        >
                                            {this.props.title}
                                        </Typography>
                                        <Table>
                                            <TableBody>
                                                { list && list.map( (row:any, index) =>
                                                    (<TableRow key={index}>
                                                        <TableCell style={{paddingRight: 0, paddingLeft: 10}}> { index + 1 } </TableCell>
                                                        <TableCell style={{paddingRight: 0}}>{row.sku}</TableCell>
                                                        <TableCell style={{paddingRight: 0}}>{row.title}</TableCell>
                                                    </TableRow>)   ) }
                                            </TableBody>
                                        </Table>
                                    </Grid>
                                </Paper>
                            </DialogContent>
                            <DialogActions className="share-table-modal-actions">
                                <Button className="filter-dialog-close" onClick={this.handleDialogClose} >
                                    Fechar
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </div>
                </div>
            </div>
        );
    }

    private handleDialogOpen = () => {
        this.setState({ dialogOpen: true });
    };

    private handleDialogClose = () => {
        this.setState({ dialogOpen: false });
    };
}



// WEBPACK FOOTER //
// ./src/component/publisher/sale/sku-sold-analytical/PublisherSkuSoldAnalytical.tsx